export class TwitchAuthCodeResponse {
  code!: string;
  scopes?: string;
}